export var createQueuesApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/queues");
    return {
        getQueue: function (queueId) {
            return http.get("".concat(url, "/").concat(queueId));
        },
        getQueues: function () {
            return http.get("".concat(url));
        },
        getStats: function () {
            return http.get("".concat(url, "/stats"));
        },
        deleteQueue: function (queueId) {
            return http.delete("".concat(url, "/").concat(queueId));
        },
        getAssignedAgents: function (queueId) {
            return http.get("".concat(url, "/").concat(queueId, "/agents"));
        },
        assignAgentToQueue: function (dto) {
            return http.post("".concat(url, "/").concat(dto.queueId, "/agents/").concat(dto.agentId), {});
        },
        removeAgentFromQueue: function (dto) {
            return http.delete("".concat(url, "/").concat(dto.queueId, "/agents/").concat(dto.agentId));
        },
        updateQueueWaitOfferOptions: function (dto) {
            return http.put("".concat(url, "/").concat(dto.queueId, "/queueWaitOfferOptions"), dto.queueWaitOfferSettings);
        },
        updateWaitOfferOptions: function (dto) {
            return http.put("".concat(url, "/").concat(dto.queueId, "/settings/waitOffers"), dto.waitOfferSettings);
        },
        updateOpeningHoursSettings: function (dto) {
            return http.put("".concat(url, "/").concat(dto.queueId, "/settings/openingHours"), dto.openingHoursSettings);
        },
        updateQueueNonAvailableAgentsSettings: function (dto) {
            return http.put("".concat(url, "/").concat(dto.queueId, "/settings/nonAvailableAgents"), dto.queueNonAvailableAgentsSettings);
        },
        updateCallOptions: function (dto) {
            return http.put("".concat(url, "/").concat(dto.queueId, "/callOptions"), dto.callOptions);
        },
        enableGlobalCallOptions: function (queueId) {
            return http.put("".concat(url, "/").concat(queueId, "/globalCallOptions/enable"), {});
        },
        disableGlobalCallOptions: function (queueId) {
            return http.put("".concat(url, "/").concat(queueId, "/globalCallOptions/disable"), {});
        },
        manualTransferBlock: function (dto) {
            var state = dto.enabled ? 'enable' : 'disable';
            return http.put("".concat(url, "/").concat(dto.queueId, "/callTransferBlock/").concat(state), {});
        },
        getQueueOpenState: function (queueId) {
            return http.get("".concat(url, "/").concat(queueId, "/schedule/openState"));
        },
    };
};
//# sourceMappingURL=index.js.map